import { SimpleTooltip } from '@g17eco/molecules/simple-tooltip';
import { AccessType, MetricGroup } from '@g17eco/types/metricGroup';

export const getMetricGroupUnitCount = (metricGroup: MetricGroup): number =>
  metricGroup.universalTracker?.length ?? metricGroup.universalTrackers?.length ?? 0;

/**
 * Returns true when populated universalTracker count differs from the universalTrackers
 * ID array count, indicating the metric group needs regeneration.
 */
export const hasMetricGroupCountMismatch = (metricGroup: MetricGroup): boolean => {
  const populatedCount = metricGroup.universalTracker?.length;
  const idCount = metricGroup.universalTrackers?.length;
  return populatedCount !== undefined && idCount !== undefined && populatedCount !== idCount;
};

export const getMetricGroupCountWarning = (metricGroup: MetricGroup): JSX.Element | undefined => {
  if (!hasMetricGroupCountMismatch(metricGroup)) {
    return undefined;
  }

  if (metricGroup.accessType === AccessType.Inherited || metricGroup.accessType === AccessType.Assigned) {
    return undefined;
  }

  return (
    <SimpleTooltip text='The displayed metric count may be inaccurate. Try regenerating this metric group.'>
      <i className='text-ThemeWarningMedium fas fa-exclamation-triangle ms-1' style={{ fontSize: '0.65em' }} />
    </SimpleTooltip>
  );
};
